export default __webpack_public_path__ + "public/assets/images/1e99ac7a44d4cf714cd4180492da0e95.png";